import { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router';
import { apiFetch, storeTokensInSession } from '../utils/Api';
import userService from '../services/userService';
import {
	eventCollectorClient,
	EventVerb,
	EventType,
} from '../services/eventCollectorService';

const AuthCallback = () => {
	const [searchParams, _setSearchParams] = useSearchParams();
	const email = sessionStorage.getItem('email');
	const navigate = useNavigate();

	const processAuth = async () => {
		const code = searchParams.get('code');

		try {
			const response = await apiFetch({
				endpoint: '/auth/callback',
				method: 'GET',
				params: { code, email },
			});

			if (response.tokens) {
				storeTokensInSession(response.tokens);
				sessionStorage.setItem('user', JSON.stringify(response.user));

				// Set auth token in event collector
				if (response.tokens.id_token) {
					eventCollectorClient.setAuthToken(response.tokens.id_token);
				}

				const now = new Date();
				const isoUtcString = now.toISOString();
				const keyVal = { last_login: isoUtcString };
				userService.updateUser(response.user.id, keyVal);

				eventCollectorClient.identify(
					response.user.sf_user_id_in_client_org,
					response.user.tenant_id
				);

				eventCollectorClient.trackEvent({
					event_name: 'USER_LOGIN',
					verb: EventVerb.Created,
					event_type: EventType.Log,
					metadata: {
						email: response.user.email,
					},
					source_domain_object: 'auth',
				});

				navigate('/');
			} else {
				console.error('Unexpected response from server while authenticating');
				sessionStorage.setItem('email', null);
				navigate('/login');
			}
		} catch (error) {
			console.error('Authentication failed:', error);
			sessionStorage.setItem('email', null);
			navigate('/login');
		}
	};

	// doing what React docs say not to, to stop calling callback twice in effect
	const submitted = useRef(null);

	useEffect(() => {
		// Abuse ref to prevent callback getting called twice in development
		if (!submitted.current) {
			submitted.current = true;

			processAuth();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <div>Authenticating...</div>;
};

export default AuthCallback;
